import { Injectable } from '@angular/core';
import { CommonChartmoduleService } from '../../../Services/common-chartmodule.service';
import { Observable, map } from 'rxjs';
import { SnapshotService } from '../../../Services/snapshot.service';

@Injectable({
  providedIn: 'root'
})
export class LineOrTrendedService {

  constructor(private commonchartmodules:CommonChartmoduleService, private _configService: SnapshotService) { }
  properties: any;

  // updatedCategories = [
  //   { name: "Oct'2023", image: 'https://th.bing.com/th/id/OIP.PJgT1Dp3KX4BbKBrfvGoFAAAAA?rs=1&pid=ImgDetMain' },
  //   { name: "Nov'2023", image: 'https://d2gg9evh47fn9z.cloudfront.net/800px_COLOURBOX7783047.jpg' },
  //   { name: "Dec'2023", image: 'https://th.bing.com/th/id/OIP.gxQmRFM-PSHbekk72mukxwHaH_?rs=1&pid=ImgDetMain' },
  //   { name: "Jan'2024", image: 'https://th.bing.com/th/id/R.4abe7f8a1272b46cb5d1e67d4341b6ec?rik=lW0lyg9V5L%2b7UQ&riu=http%3a%2f%2fwww.mapsof.net%2fuploads%2fstatic-maps%2feuropecontour.png&ehk=aDTomnr7%2bgplizpCBegO2ztJrXsGolh7sWqvGkqOQAI%3d&risl=&pid=ImgRaw&r=0' },
  //   { name: "Feb'2024", image: 'https://media.istockphoto.com/vectors/black-silhouette-country-borders-map-of-india-on-white-background-of-vector-id955286158?k=6&m=955286158&s=170667a&w=0&h=zeBvYe1ttcA8HTslBhAfLRfzS0q2D3o7LQ9Jtp8ift4=' },
  // ];
  color1:string[]=this.commonchartmodules.color1;
  commonFunc(customization: any, event: any, property: any) {
    this.properties = property;
    switch (customization) {
      case 'Gridlines':
        this.properties.gridlines = event.target.classList.toggle('checked')? 1 : 0;
        break;
      case 'Stacked Chart : ':
        this.properties.stacking = event.target.value;
        break;
      case 'Dark Theme':
        this.properties.darkTheme = event.target.classList.toggle('checked');
        break;
      case 'Legend : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showLegend = value == 'enabled' ? true : false;
        break;
      case 'Legend Position : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.legendPosition = value;
        break;

      case 'Data Label Format : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelFormat = value;
        break;
      case 'Axis Label Orientation : ': 
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      this.properties.axisLabelOrientation = value;
        break;
      case 'Chart Title Position : ': 
      var clickedDiv = event.currentTarget as HTMLDivElement;
      var value = clickedDiv.getAttribute('value');
      this.properties.chartTitlePosition = value;
        break;
      case 'Data Label : ': 
      var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.showDataLabel = value == 'enable' ? true : false;
        break;
      case 'Data Label Property : ': this.properties.datalabelStyle = event.target.value;
        break;
      case 'Data Label Position : ': this.properties.dataLabelPositionPPT = event.target.value;
        break;
      case 'Data Label Size# : ':
        this.properties.dataLabelSize = event.target.value;
        break;
      case 'Data Label Orientation : ':
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        this.properties.datalabelOrientation = value;
        break;
      case 'Data Label Color : ': this.properties.dataLabelColor = event.target.value;
        break;
      case 'Axis Image': this.properties.axisImage = event.target.classList.toggle('checked');;
        break;
      case 'Chart Style : ': this.properties.chartStyle = event.target.value;
        break;
      case "Line Style : ":
        this.properties.gridLineDashStyle = event.target.value;
        break;
      case 'Marker Style : ':
        this.properties.markerStyle = event.target.value;
        break;
      case 'ToolTip Style# : ':
        this.properties.toolTipStyle = event.target.value;
        break;
      default:

        break;
    }
        return this.properties
  }

  axisLabelOrientation(axisLabelOrientation: any) {
    let rotationValue = 0;
    switch (axisLabelOrientation) {
      case 'vertical':
        rotationValue = -90; // or 90 depending on your preference
        break;
      case 'angled':
        rotationValue = -45; // or -90 depending on your preference
        break;
      default:
        rotationValue = 0;
        break;
    }
    return rotationValue
  }

  customizationService() {
    let custom: any = [
      { customization: 'Dark Theme', func: 'commonfunc', inputType: 'checkbox', className: '', id:'Dark Theme' },
      { customization: 'Gridlines', func: 'commonfunc', inputType: 'checkbox', className: '', id: 'Gridlines' },
      { customization: 'Axis Image', func: 'commonfunc', inputType: 'checkbox', className: '', id: 'Axis Image' },
      {
        customization: 'Axis Label Orientation : ',
        func: 'commonfunc',
        inputType: 'images', className: '', id: 'Axis Label Orientation : ', options: [
          { value: 'horizontal', label: 'Horizontal',selected:true,imgClassName:'axisHorizontal',selectedImgClassName:'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical',selected:false,imgClassName:'axisVertical',selectedImgClassName:'axisVerticalSelected' },
          { value: 'angled', label: 'Angled',selected:false,imgClassName:'axisAngled',selectedImgClassName:'axisAngledSelected' },
        ]
      },
      {
        customization: 'Stacked Chart : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Stacked Chart : ',options: [
          { value: 0, label: 'Without Stack' },
          { value: 1, label: 'Stacking' },
          { value: 2, label: '100% Stacking' }]
      },
      {
        customization: 'Line Style : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Line Style : ',options: [
          { value: 'Dash', label: 'Dash' },
          { value: 'DashDot', label: 'DashDot' },
          { value: 'Dot', label: 'Dot' },
          { value: 'LongDash', label: 'LongDash' },
          { value: 'LongDashDot', label: 'LongDashDot' },
          { value: 'LongDashDotDot', label: 'LongDashDotDot' },
          { value: 'Solid', label: 'Solid' }
        ]
      },
      {
        customization: 'Marker Style : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'Marker Style : ', options: [
          { value: 'circle', label: 'Circle' },
          { value: 'diamond', label: 'Diamond' },
          { value: 'square', label: 'Square' },
          { value: 'triangle', label: 'Triangle' },
        ]
      },
      {
        customization: 'ToolTip Style# : ', func: 'commonfunc', inputType: 'dropdown', className: '', id: 'ToolTip Style# : ', options: [
          { value: 'default', label: 'Default' },

          { value: 'style1', label: 'Style1' },
        ]
      },
      {
        customization: 'Chart Title Position : ', func: 'commonfunc', inputType: 'images', className: '', id: 'Chart Title Position : ', options: [
          { value: 'left', label: 'Left' ,selected:false,imgClassName:'titleLeft',selectedImgClassName:'titleLeftSelected'},
          
          { value: 'center', label: 'Center',selected:true,imgClassName:'titleCenter',selectedImgClassName:'titleCenterSelected' },
          { value: 'right', label: 'Right',selected:false,imgClassName:'titleRight',selectedImgClassName:'titleRightSelected' },

        ]
      },
      {
        customization: 'Legend : ', func: 'commonfunc', inputType: 'images', className: 'Legend', id: 'Legend : ',options: [
          { value: 'enabled', label: 'Enable',selected:true,imgClassName:'legendEnable',selectedImgClassName:'legendEnableSelected' },
          { value: 'disabled', label: 'Disable',selected:false,imgClassName:'legendDisable',selectedImgClassName:'legendDisableSelected' },
        ]
      },
      {
        customization: 'Position : ', func: 'commonfunc', inputType: 'images', className: 'LegendGrouping', id: 'Legend Position : ', options: [
          { value: 'left', label: 'Left',selected:false,imgClassName:'legendLeft',selectedImgClassName:'legendLeftSelected' },
          { value: 'bottom', label: 'Bottom',selected:true,imgClassName:'legendBottom',selectedImgClassName:'legendBottomSelected' },
          { value: 'right', label: 'Right',selected:false,imgClassName:'legendRight',selectedImgClassName:'legendRightSelected' },  // Add this option for 'Right'
        ]
      },
      {
        customization: 'Data Label : ', func: 'commonfunc', inputType: 'toggle', className: 'DataLabel', id: 'Data Label : ', options: [
          { value: 'enable', label: 'On',selected:true },
          { value: 'disable', label: 'Off',selected:false },
        ]
      },
      {
        customization: 'Format : ', func: 'commonfunc', inputType: 'images', className: 'DataLabelGrouping', id: 'Data Label Format : ', options: [
          { value: 'number', label: 'number',selected:true,imgClassName:'formatNumber',selectedImgClassName:'formatNumberSelected' },
          { value: 'percentage', label: 'percentage',selected:false,imgClassName:'formatPercentage',selectedImgClassName:'formatPercentageSelected' },
        ]
      },
      { "customization": "Color : ", "func": "commonfunc", "inputType": "color", className: 'DataLabelGrouping', id: 'Data Label Color : ', "value": "#000000" },
      {
        customization: "Property : ", func: 'commonfunc', inputType: 'dropdown', className: 'DataLabelGrouping', id: 'Data Label Property : ', options: [
          { value: 'default', label: 'Default' },
          { value: 'change', label: 'Change Versus' },
          { value: 'sigchan', label: 'Change Versus + Significance' },
          { value: 'significance', label: 'Significance' },
          { value: 'significance2', label: 'Significance Level2' },
          { value: 'lowSample', label: 'Low Sample' },
        ]
      },
      {
        customization: 'Size# : ', func: 'commonfunc', inputType: 'dropdown', className: 'DataLabelGrouping', id: 'Data Label Size# : ', options: [
          { value: '1em', label: '1 em' },
          { value: '0.9em', label: '0.9 em' },
          { value: '0.8em', label: '0.8 em' },
          { value: '0.7em', label: '0.7 em' },
        ]
      },
      {
        customization: 'Position : ', func: 'commonfunc', inputType: 'dropdown', className: 'DataLabelGrouping', id: 'Data Label Position : ', options: [
          { value: 'center', label: 'Center' },
          { value: 'left', label: 'Left' },
          { value: 'right', label: 'Right' },
        ]
      }
    ];
    return custom;
  }


  customizeLegend(showLegend: any, legendPosition: any, theme: any, stacking: any): Highcharts.LegendOptions {
    let alignLegend: Highcharts.VerticalAlignValue = 'bottom'; // Default value
    let alignx: Highcharts.AlignValue | undefined = 'left';
    let layout1: Highcharts.OptionsLayoutValue | undefined = 'horizontal';
    let legendWidthValue: any = null;
    if (showLegend) {
      switch (legendPosition) {
        case "top":
          alignLegend = 'top';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "bottom":
          alignLegend = 'bottom';
          alignx = 'center';
          layout1 = 'horizontal';
          break;
        case "right":
          alignLegend = 'middle';
          alignx = 'right';
          layout1 = 'vertical';
          legendWidthValue = '20%';
          break;
        case "left":
          alignLegend = 'middle';
          alignx = 'left';
          layout1 = 'vertical';
          break;
        default:
          // No need to change anything for the default case
          break;
      }
    }

    return {
      enabled: showLegend,
      reversed: (stacking == 1 || stacking == 2) ? true : false,
      align: alignx,
      verticalAlign: alignLegend,
      layout: layout1,
      itemStyle: {
        color: theme ? "white" : "Black",
        fontWeight: "normal",
        fontSize: "0.8em",
        fontFamily: "KantarBrown-Regular"
      },
      width: legendWidthValue
    };
  }


  applycustomization(event:any,item:any,properties:any){
    this.commonchartmodules.applycustomization(event,item,properties)
  }
  
  list:any;
  Line1CustomizationList():Observable<any[]>{
    return this.commonchartmodules.getCustomization().pipe(
      map(data => {
        this.list = JSON.parse(data);
        this.list = this.list.filter((item: any) => item.Chart.trim() == "Line Chart")
        let custom: any[] = [];
        custom.push({
          customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
          options: this._configService.clientSnapshotAllStudyNames
        });
        if (this.list[0].MetricDropDownWithoutAxis) custom.push(this.commonchartmodules.customizationObject.NumberOfMetricVisible(this.list[0].NumberOfMetricVisible));
        custom.push(this.commonchartmodules.customizationObject.WidgetName);
        if (this.list[0].Xaxis) custom.push(this.commonchartmodules.customizationObject.XAxis);
        if (this.list[0].Yaxis) custom.push(this.commonchartmodules.customizationObject.YAxis);
        if (this.list[0].Zaxis) custom.push(this.commonchartmodules.customizationObject.ZAxis);
        if (this.list[0].XAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.XAxisLabelOrientation);
        if (this.list[0].YAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.YAxisLabelOrientation);
        if (this.list[0].ZAxisLabelOrientation) custom.push(this.commonchartmodules.customizationObject.ZAxisLabelOrientation);
        custom = [...custom, ...this.commonchartmodules.commoncustomizationlist().slice(0,this.commonchartmodules.commoncustomizationlist().length-1)]
        custom.push( {
          customization: 'Position : ',
          func: 'applycustomization',
          inputType: 'dropdown',
          className: 'DataLabelGrouping',
          id: 'Data Label Position',
          options: [
            { value: 'center', label: 'Center' },
            { value: 'left', label: 'Left' },
            { value: 'right', label: 'Right' },
          ],
        },)
        return custom;
      })
    );
  
  }
  

   customization() {
    let custom: any = [
      {
        customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',options: this._configService.clientSnapshotAllStudyNames
      },
      {
        customization:'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '',select:1,options: [
          { value: 'metric1', label: 'Metric 1' },{ value: 'metric2', label: 'Metric 2' },{ value: 'metric3', label: 'Metric 3' },{ value: 'metric4', label: 'Metric 4' },
        ]
      },
      {
        customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
      },
      {
        customization:'X Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'X Axis Label Orientation',options: [
          { value: 'automatic', label: 'Automatic' },
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
      {
        customization:'Y Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'Y Axis Label Orientation',options: [
          { value: 'automatic', label: 'Automatic' },
          { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
          { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
          { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        ]
      },
      {
        customization: 'Decimal Round Off : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: 'Decimal Round Off',
        options: [{ value: 0, label: 'None' },
        { value: 1, label: 'One Decimal Point' },
        { value: 2, label: 'Two Decimal Point' }],
      },
      {
        customization: 'Info Button : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: '',
        options: [{ value: 'none', label: 'None' }],
      },
      {
        customization: 'Legend : ',
        func: 'applycustomization',
        inputType: 'images',
        className: 'Legend',
        id: 'Legend',
        options: [
          {
            value: 'enable',
            label: 'Enable',
            selected: false,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
          {
            value: 'disable',
            label: 'Disable',
            selected: true,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
        ],
      },
      {
        customization: 'Position : ',
        func: 'applycustomization',
        inputType: 'images',
        className: 'LegendGrouping',
        id: 'Legend Position',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'legendLeft',
            selectedImgClassName: 'legendLeftSelected',
          },
          {
            value: 'bottom',
            label: 'Bottom',
            selected: true,
            imgClassName: 'legendBottom',
            selectedImgClassName: 'legendBottomSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: false,
            imgClassName: 'legendRight',
            selectedImgClassName: 'legendRightSelected',
          }, // Add this option for 'Right'
        ],
      },
      {
        customization: 'Data Label : ',
        func: 'applycustomization',
        inputType: 'toggle',
        className: 'DataLabel',
        id: 'Data Label',
        options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ],
      },
      {
        customization: 'Color : ',
        func: 'applycustomization',
        inputType: 'color',
        className: 'DataLabelGrouping',
        id: 'Data Label Color',
        value: '#000000',
      },

      {
        customization: 'Property : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Property',
        options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Versus ' },
          {
            value: 'significance + changeVs',
            label: 'Change Versus + Significance',
          },

          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },

          { value: 'ls', label: 'Low Sample ' },
        ],
      },

      {
        customization: 'Size : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Size',
        options: [
          { value: '1em', label: '1 Em' },
          { value: '0.9em', label: '0.9 Em' },
          { value: '0.8em', label: '0.8 Em' },
          { value: '0.7em', label: '0.7 Em' },
        ],
      },
      {
        customization: 'Position : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Position',
        options: [
          { value: 'center', label: 'Center' },
          { value: 'left', label: 'Left' },
          { value: 'right', label: 'Right' },
        ],
      },
    ];
    custom=[...custom];
  
    return custom;
  }
}
